import { extendWith } from "lodash";

// gallery swiper
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const Emoji = require('./Emoji');

// Sprites do seletor de emoji (8,4 MB): só entram na página quando algum seletor é criado. URL versionada no data-emoji-css do body.
function carregarEmojiCss() {
    const url = document.body && document.body.dataset.emojiCss;
    if (!url || document.getElementById('vendor-emoji-css')) return;
    const link = document.createElement('link');
    link.id = 'vendor-emoji-css';
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
}

// .execute-ajax-on-load em voo: { element, xhr }. Módulo (não instância): há várias UtilitiesUP na página.
const ajaxOnLoadPendentes = new Set();

export default class UtilitiesUP {

    constructor() {
    }

    switchReturns(data, element, returnCallback = false) {
        switch (data.result.method) {
            case 'composition-add':
                let result = data.result;

                $('#collapseOne-' + result.id).collapse('hide');
                $('#resume-composition-' + result.id).find('.box-item').html(result.html);
                $('#resume-composition-' + result.id).find('.text-init').hide();

                this.calculateComposition();

                break;
            case 'opacity':

                break;
            case 'sync':
                var id = data.result.target;

                $('#' + id).replaceWith(data.result.html);

                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'status':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    var id = element.data('target_id');
                    if (data.result.active == '1') {
                        $('#' + id).addClass('active-line').removeClass('inactive-line');
                        element.find('i').addClass('fa-toggle-on').removeClass('fa-toggle-off');
                    } else {
                        $('#' + id).addClass('inactive-line').removeClass('active-line');
                        element.find('i').addClass('fa-toggle-off').removeClass('fa-toggle-on');
                    }
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'newListItem':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('.' + data.result.target).prepend(data.result.html);
                    $('#myModal' + COUNT_MODAL).modal("hide");
                    // $('#myModal' + COUNT_MODAL).remove();
                    // $('.modal-backdrop').last().remove();
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'replaceListItem':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#' + data.result.target).replaceWith(data.result.html);
                    //$('#myModal' + COUNT_MODAL).modal("hide"); // 24-06 ao salvar modal nao fecha automatico
                    // $('#myModal' + COUNT_MODAL).remove();
                    // $('.modal-backdrop').last().remove();
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'componentProposal':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {

                    $('#' + data.result.target_show).html(data.result.html);
                    this.formSelects();

                    this.calculateComposition();

                    $('#' + data.result.target_hide).hide();
                    $('#' + data.result.target_show).show();

                    $('#myModal' + COUNT_MODAL).modal("hide");
                    // $('#myModal' + COUNT_MODAL).remove();
                    // $('.modal-backdrop').last().remove();
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");

                }
                break;
            case 'addElement':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#' + data.result.target).replaceWith(data.result.html);
                    this.btRemoveLine(data.result.target);
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break
            case 'prependElement':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $(data.result.target).prepend(data.result.html);
                    this.btRemoveLine(data.result.target);
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                }
                break
            case 'appendElement':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $(data.result.target).append(data.result.html);
                }
                break
            case 'replaceContent':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    this.abortAjaxOnLoad(data.result.target);
                    $(data.result.target).html(data.result.html);
                    // $('#myModal' + COUNT_MODAL).modal("hide");
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                    this.checkChart();
                    this.formSelects();
                    this.masksInputs();
                    this.executeAjaxOnLoad(data.result.target);
                    if (data.result.chatRoom) $(document).trigger('chat:room', [data.result.chatRoom]);   // Chats.js entra na sala do Pusher
                }
                break;
            case 'replaceElement':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    console.log('teste aqui2')
                    console.log($(data.result.target))
                    $(data.result.target).replaceWith(data.result.html);
                    $('#myModal' + COUNT_MODAL).modal("hide");
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                    this.checkChart();
                    this.formSelects();
                }
                break;
            case 'replaceContentInModal':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $(data.result.target).html(data.result.html);
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'replaceElementInModal':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $(data.result.target).replaceWith(data.result.html);
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'appendElementInModal':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $(data.result.target).append(data.result.html);

                    $(element).find('.textarea-modal-ticket').val('');
                    if ($('.ckeditor-simple').length > 0) {
                        $(element).find('.textarea-modal-ticket').find('.ck-content').empty();

                        // scroll ate ultimo ticket
                        let idLastAccord = $('.accordion.accordion-toggle-arrow').last().find('.accordion-arrow-inverse').attr('data-target')
                        $(idLastAccord).collapse('show');

                        // console.log(idLastAccord);

                        $('.modal-content-scrollable-custom').animate({
                            scrollTop: $('.accordion.accordion-toggle-arrow').last().offset().top
                        }, 800);

                        // reseta os ckeditors
                        setTimeout(() => {
                            $(element).find('.ckeditor-simple').each(function () {
                                const id = this.id;

                                if (window.editors[id]) {
                                    window.editors[id].setData('');
                                }
                            });
                        }, 500);
                    }
                    // if(data.message !='') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'replaceMultipleElement':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {

                    $('#myModal' + COUNT_MODAL).modal("hide");

                    data.result.targets.forEach(function (value, index) {
                        $(value.target).html(value.html);
                    });

                    if ($('#kt_chat_content').length > 0) {
                        $('.scroll').animate({
                            scrollTop: $('.messageBody')[0] !== undefined ? $('.messageBody')[0].scrollHeight : 1
                        }, 1000);
                    }

                }
                break;
            case 'redirect':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                    setTimeout(function () {
                        if(data.newWindow == true){
                            window.open(data.result.target, '_blank');
                        }else{
                            window.location.href = data.result.target;
                        }
                    }, 1000);
                }
                break;
            case 'reload':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }

                break;
            case 'reload-error':
                // this.showAlert(data.message, "Ok", "error");
                location.reload();
                break;
            case 'table':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('.' + data.result.target).html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center force-center"></div>');
                    $('.' + data.result.target).html(data.result.html);
                }
                break;
            case 'remove-element':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#' + data.result.target).remove();
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'remove-notification':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#' + data.result.target).remove();
                }
                break;
            case 'addCategory':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    if ($('#' + data.result.target + data.result.level).length > 0) {
                        $('#' + data.result.target + data.result.level).replaceWith(data.result.html);

                        $('.card-category').each(function () {
                            if (parseInt($(this).attr('data-level')) > data.result.level) {
                                $(this).remove();
                            }
                        });
                    } else {
                        $('.' + data.result.container).append(data.result.html);
                    }
                    this.scrollToElement($('#' + data.result.target + data.result.level));
                    this.sortable();
                }
                break;
            case 'remove-category':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#' + data.result.target).remove();
                    $('.card-category').each(function () {
                        if (parseInt($(this).attr('data-id')) == data.result.id) {
                            $(this).remove();
                        }
                    });

                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'img-status':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    var target = element.data('target');
                    if (data.result.active == '1') {
                        $('.' + target).removeClass('grayscale');
                    } else {
                        $('.' + target).addClass('grayscale');
                    }
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            case 'changeTab':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    this.changeTab()
                }
                break;
            case 'replace-multi-elements':
                let elements = data.result.elements;

                elements.forEach(function (value, index) {
                    $(value.target).html(value.html);
                });

                break;
            case 'without-notification':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                }
                break;
            case 'modalFeedCall':
                // console.log('entrou minha funcao');
                showModal('', $("#callOpp").data('callback'));
                break;
            case 'modalNotClose':
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
            default:
                if (data.error) {
                    this.showAlert(data.message, "Ok", "error");
                } else {
                    $('#myModal' + COUNT_MODAL).modal("hide");
                    if (data.message != '') this.showAlert(data.message, "Ok", "success");
                }
                break;
        }

        if (element.data('callback') != undefined && returnCallback == false) {
            var url_ajax = element.data('callback');

            setTimeout(function () {
                $.ajax({
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    },
                    url: url_ajax,
                    data: [],
                    dataType: "json",
                    success: function (data) {
                        var classUtilitites = new UtilitiesUP;

                        // $('html').css('overflow', 'auto');

                        classUtilitites.switchReturns(data, element, true);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        var classUtilitites = new UtilitiesUP;

                        // $('html').css('overflow', 'auto');

                        classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                        if (APP_DEBUG != "ON") {
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        }
                    }
                })
            }, 0);
        }
    }

    sortable() {
        var containers = document.querySelectorAll('.draggable-zone');
        if (containers.length === 0) {
            return false;
        }

        // $(".draggable-zone").sortable('destroy');

        [].forEach.call(containers, function (div) {
            new Sortable.default(div, {
                draggable: '.draggable',
                handle: '.draggable .draggable-handle',
                mirror: {
                    appendTo: 'body',
                    constrainDimensions: true
                }
            }).on('sortable:stop', function (response) {
                setTimeout(function () {
                    var container = response.data.newContainer.id;
                    var url = $('#' + container).attr('data-ajax');
                    var sorting = [];

                    $('#' + container).find('.draggable').each(function (index) {
                        var el = $(this);
                        sorting[index] = el.attr('data-id');
                    });

                    $.post(url, {
                        sorting: sorting
                    }, function (data) {

                    }, 'json');

                }, 500);
            });
        });
    }

    showCommunicationError(error) {
        // Só falha HTTP/rede do axios é erro de comunicação; bug de JS no .then deve aparecer no console.
        if (error && !error.isAxiosError) throw error;

        this.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
    }

    showAlert(msg, btn = "", icon = "error", confirmButton = false, input = "") {

        if (confirmButton == false) {
            var attr_msg = {
                html: msg,
                icon: icon,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn font-weight-bold btn-light"
                }
            };

            if (btn != "") {
                attr_msg.confirmButtonText = btn;
            }

            Swal.fire(attr_msg).then(function () {
                // KTUtil.scrollTop();
                // setTimeout(() => {
                //     $('button.close').trigger('click');
                // }, 1000);
            });
        } else {
            var retorno = false;

            var params = {
                title: title_msg_alert,
                html: msg,
                icon: icon,
                showCancelButton: true,
                confirmButtonText: confirm_msg_alert,
                cancelButtonText: cancel_msg_alert,
                reverseButtons: true
            };

            if (input != "") {
                params.assign('input', 'text');
                params.assign('inputAttributes', {
                    placeholder: text
                });
            }

            Swal.fire(params).then(function (result) {
                retorno = result.value;
            });

        }
    }

    removeLine() {
        var element = $(this);
        var target = element.data('target');

        this.btRemoveLine(target);
    }

    btRemoveLine(id) {
        $('#edit_' + id).find('div:eq(0)').slideToggle('slow', function () {
            $('#edit_' + id).remove();
        });
    }

    calculateComposition() {

        var total = 0;

        $('.product-selected').each(function () {
            var element = $(this);
            var elementPrice = 0;

            if (element.find('.component-qty').length > 0) {
                elementPrice = parseFloat(element.find('.component-qty').attr('data-price')) * parseFloat(element.find('.component-qty').val());
            } else {
                elementPrice = parseFloat(element.attr('data-price'));
            }

            total = total + elementPrice;
        });

        total = total + parseFloat($('.main-product').data('price'));

        total = total.toLocaleString('pt-br', { minimumFractionDigits: 2 });

        $('.total-price').html($('.main-product').data('symbol') + " " + total);
    }

    scrollToElement(ele) {
        $("html, body").animate({ scrollTop: $(ele).offset().top }, 500);
    }

    formSelects() {
        // // loading data from array
        // var data = [{
        //     id: 0,
        //     text: 'Enhancement'
        // }, {
        //     id: 1,
        //     text: 'Bug'
        // }, {
        //     id: 2,
        //     text: 'Duplicate'
        // }, {
        //     id: 3,
        //     text: 'Invalid'
        // }, {
        //     id: 4,
        //     text: 'Wontfix'
        // }];

        // $('.select[multiple="multiple"]').select2({
        //     placeholder: "Select a value",
        //     data: data
        // });

        let closingEmojiPicker = false;
        $(document).on('mousedown', '.emoji', function () {
            if (closingEmojiPicker) return;
            closingEmojiPicker = true;
            setTimeout(function () {
                $('.emojiPicker').hide();
                closingEmojiPicker = false;
            }, 100);
        });

        $('.trigger-emoji').each(function () {
            var el = $($(this).attr('data-target'));

            if (!el.data('emojiPicker')) {
                carregarEmojiCss();
                el.addClass('emoji-picker-el');
                el.emojiPicker({
                    width: '300px',
                    height: '200px',
                    button: false,
                    onShow: function (picker, settings, isActive) {
                        var pos = $(picker).position();
                        let posL = $(el).offset().left;
                        $(picker).css({
                            'top': pos.top - (el.height() + 220),
                            'left' : posL,
                            'right' : 'auto'
                        });

                    }
                });
            }
        });

        $('[data-toggle="tooltip"]').tooltip();

        $('.select').select2({
            placeholder: function () {
                return $(this).attr("placeholder");
            }
            ,
            matcher: function (params, data) {
                return searchSelect2(params, data);
            }
        });

        function searchSelect2(params, data) {
            var terms, text;
            if (params.term == null) {
                return data;
            }
            terms = params.term.toUpperCase().split(' ');
            text = data.text.toUpperCase();
            if (terms.every(function (term) {
                if (text.indexOf(term) > -1) {
                    return true;
                }
            })) {
                return data;
            } else {
                return null;
            }
        };

        // $('.select2').not('.select2-hidden-accessible').select2();

        $('.select-plugin').select2({
            allowClear: true,
            placeholder: function () {
                return $(this).attr("placeholder");
            }
        });

        $('.select-ajax').not('.select2-hidden-accessible').each(function () {
            var $select = $(this);

            $select.select2({
                placeholder: function () {
                    return $select.attr("placeholder");
                },
                allowClear: true,
                ajax: {
                    url: function () {
                        return $select.attr('data-ajax');
                    },
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term, // search term
                            page: params.page
                        };
                    },
                    processResults: function (data) {
                        // Transforms the top-level key of the response object from 'items' to 'results'
                        return {
                            results: data.results
                        };
                    },
                    cache: true
                },
                escapeMarkup: function (markup) {
                    return markup;
                }, // let our custom formatter work
                // data-min-input-length overrides the default of 0 (search fires on open, without typing).
                minimumInputLength: $select.data('min-input-length') !== undefined ? parseInt($select.data('min-input-length'), 10) : 0
            });
        });

        window.editors = {};
        if ($('.ckeditor-simple').length > 0) {
            $('.ckeditor-simple').not('.ignore-rebuild').each(function () {
                const el = this;
                const id = el.id;
                ClassicEditor.create(document.querySelector("#" + $(this).attr('id')), {
                    toolbar: ["undo", "redo", "bold", "italic", "link", "numberedList", "bulletedList", "insertTable"],
                    link: {
                        decorators: {
                            addTargetToExternalLinks: {
                                mode: 'automatic',
                                callback: url => /^(https?:)?\/\//.test(url),
                                attributes: {
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                }
                            },
                        }
                    }
                })
                    .then(editor => {
                        window.editors[id] = editor;
                    })
                    .catch(error => {
                        console.log(error);
                    });
                $(this).addClass('ignore-rebuild');
            });
        }
        if ($('.carousel').length > 0) {
            $('.carousel').carousel();
        }

        $('input[data-disable-dates]').datepicker({
            format: "dd/mm/yyyy",
            language: "pt-BR",
            autoclose: true,
            datesDisabled: $('#checkin').data('disable-dates'),
            minDate: 1
        });

        if ($(document).find('.process-ajax').length > 0) {
            this.processAjax($(document).find('.process-ajax').first())
        }

        if ($(document).find('.trigger-emoji').length > 0) {
            Emoji.init();
        }
    }

    /* createOldForm() {
        if ($('form').hasClass('check-save')) {
            var form_old = $('form.check-save').serializeArray();
            form_old_fields = [];

            $.map(form_old, function (n, i) {

                if ($('select[name="' + n['name'] + '"]') != undefined && $('select[name="' + n['name'] + '"]').hasClass('select2')) {
                    if (n['name'].indexOf('[]')) {
                        var seletedVal = "";
                        $('select[name="' + n['name'] + '"] option:selected').each(function () {
                            seletedVal = seletedVal + (seletedVal != "" ? "," + $(this).val() : $(this).val());
                        });

                        form_old_fields[n['name'].replace('[]', '')] = seletedVal;
                    }
                    form_old_fields[n['name']] = $('select[name="' + n['name'] + '"]').val();

                    // $('select[name="'+$(this).attr('name')+'"] option:selected')
                }


                form_old_fields[n['name']] = n['value'];
            });

            window.onbeforeunload = function () {
                var classUtilitites = new UtilitiesUP;
                if (classUtilitites.checkFormHasChange(false)) {
                    if (submittedForm === false) {
                        return 'Existem alterações não salvas. Tem certeza que deseja sair?';
                    }
                }

            };
        }
    } */
    createOldForm() {
        console.log('--createOldForm--');
        var $form = $('form.check-save');
        if ($form.length > 0) {
            var form_old = $form.serializeArray();
            form_old_fields = {}; // Usar objeto em vez de array para mapear chave -> valor
            // 1. Processa os campos normais vindos do serializeArray
            $.each(form_old, function (i, n) {
                var $select = $('select[name="' + n.name + '"]');
                // Se for um select múltiplo (nativo ou Select2)
                if ($select.length > 0 && ($select.prop('multiple') || n.name.includes('[]'))) {
                    var selectedVals = $select.val() || []; // Retorna um array com todos os selecionados, ex: ["1", "2"]
                    var valString = Array.isArray(selectedVals) ? selectedVals.join(',') : selectedVals;
                    // Armazena tanto com '[]' quanto sem '[]' para garantir compatibilidade com seu comparador
                    form_old_fields[n.name] = valString;
                    form_old_fields[n.name.replace('[]', '')] = valString;
                } else {
                    // Se o campo já existe (ex: checkboxes múltiplos), podemos acumular ou apenas atribuir
                    form_old_fields[n.name] = n.value;
                }
            });
            // 2. Garante que selects múltiplos vazios também fiquem registrados
            $form.find('select[multiple]').each(function () {
                var name = $(this).attr('name');
                if (name) {
                    var val = $(this).val() || [];
                    var valString = Array.isArray(val) ? val.join(',') : val;
                    if (form_old_fields[name] === undefined) {
                        form_old_fields[name] = valString;
                        form_old_fields[name.replace('[]', '')] = valString;
                    }
                }
            });
            window.onbeforeunload = function () {
                var classUtilitites = new UtilitiesUP();
                if (classUtilitites.checkFormHasChange(false)) {
                    if (typeof submittedForm !== 'undefined' && submittedForm === false) {
                        return 'Existem alterações não salvas. Tem certeza que deseja sair?';
                    }
                }
            };
        }
    }

    checkFormHasChange(showConfirm = false) {
        var result = false;

        if (Object.keys(form_old_fields).length === 0 && $('form.check-save').serializeArray().length > 0) {
            result = true;
        }

        $('form.check-save').find('input, textarea, select').each(function () {
            var nameField = String($(this).attr('name'));

            if (Object.keys(form_old_fields).length > 0 && nameField !== 'undefined') {

                if ($(this).prop("tagName") == 'SELECT' && $(this).hasClass('select2') && $(this).attr('multiple') != undefined) {

                    if (form_old_fields[$(this).attr('name').replace('[]', '')] != undefined) {
                        var oldSelect = form_old_fields[$(this).attr('name').replace('[]', '')].split(',');
                        var newSelect = String($(this).val().toString().replace(/\s/g, '').replace(/&nbsp;/g, '')).split(',');

                        let checker = (arr, target) => target.every(v => arr.includes(v));

                        result = (newSelect.length < oldSelect.length || newSelect.length > oldSelect.length || !checker(newSelect, oldSelect));

                    }


                } else if ($(this).prop("tagName") == 'SELECT' && $(this).hasClass('select2') && $(this).attr('multiple') == undefined && (String($(this).val().toString().replace(/\s/g, '').replace(/&nbsp;/g, '')).trim() != String(form_old_fields[nameField]).trim())) {
                    result = true
                } else if ($(this).hasClass('ckeditor-simple')) {
                    let valueEditor = String($(this).closest('div').find('.ck-content').html().replace(/(<([^>]+)>)/gi, "").toString().replace(/\s/g, '').replace(/&nbsp;/g, '').replace('<p><brdata-cke-filler="true"></p>', '').replace('<p><br><brdata-cke-filler="true"></p>', ''));
                    let valueEditor2 = String(form_old_fields[nameField].toString().replace(/(<([^>]+)>)/gi, "").replace(/\s/g, '').replace(/&nbsp;/g, '').replace('<p><brdata-cke-filler="true"></p>', '').replace('<p><br><brdata-cke-filler="true"></p>', ''));

                    if (valueEditor != '<p><brdata-cke-filler="true"></p>' && htmlDecode(valueEditor) != htmlDecode(valueEditor2)) {
                        result = true;
                    }

                } else if (form_old_fields[nameField] !== undefined && (String($(this).val().toString().replace(/\s/g, '').replace(/&nbsp;/g, '')) != String(form_old_fields[nameField].toString().replace(/\s/g, '').replace(/&nbsp;/g, '')))) {

                    /* console.log(String($(this).val().toString().replace(/\s/g, '').replace(/&nbsp;/g, '')), '=', String(form_old_fields[nameField].toString().replace(/\s/g, '').replace(/&nbsp;/g, ''))); */

                    result = true;
                } else if (form_old_fields[nameField] !== undefined && (($(this).attr('type') == 'checkbox') || ($(this).attr('type') == 'radio')) && (!$(this).is(':checked'))) {
                    if (($(this).attr('type') == 'checkbox') || ($(this).attr('type') == 'radio')) {

                        if (form_old_fields[nameField] === undefined && $(this).is(':checked')) {
                            result = true;
                        } else if (form_old_fields[nameField] !== undefined && !$(this).is(':checked')) {
                            result = true;
                        }

                    } else {
                        result = true;
                    }

                } else if (form_old_fields[nameField] === undefined && String($(this).val().toString().replace(/\s/g, '').replace(/&nbsp;/g, '')) != "") {
                    if (($(this).attr('type') == 'checkbox') || ($(this).attr('type') == 'radio')) {

                        if (form_old_fields[nameField] === undefined && $(this).is(':checked')) {
                            result = true;
                        } else if (form_old_fields[nameField] !== undefined && !$(this).is(':checked')) {
                            result = true;
                        }

                    } else {
                        result = true;
                    }

                }
            }
        });

        if (result) {
            if (showConfirm === true) {
                result = confirm('Existem alterações não salvas. Tem certeza que deseja sair?');
            }

            return result;
        } else {
            if (showConfirm === true) {
                result = true;
            }
        }

        return result;
    }

    changeTab() {
        var element = $(this);
        var url_ajax = $(this).data("ajax");
        var divTarget = $(this).data("target");
        const idSidebar = $(this).data("sidebar");
        var continueProcess = true;
        var classUtilitites = new UtilitiesUP;

        // classUtilitites.formInfoLoad(idSidebar);

        if ($('form').hasClass('check-save')) {
            continueProcess = classUtilitites.checkFormHasChange(true);
        }

        if (continueProcess) {
            $('.' + divTarget).html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center force-center"></div>');

            $.ajax({
                type: "GET",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: {},
                dataType: "json",
                success: function (data) {

                    var classUtilitites = new UtilitiesUP;

                    if (data.error) {
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {
                        $('.' + divTarget).html(data.result.html);
                        classUtilitites.formSelects();
                        classUtilitites.createOldForm();
                        if ($('form').length > 0) {
                            $('form').each(function (element) {
                                if ($(this).hasClass('no-validate') === false) {
                                    window._formValidade($(this));
                                }
                            });
                        }
                        if (typeof window._repeaterListInit === 'function') {
                            window._repeaterListInit();
                        }
                        if (typeof window._groupRepeaterListInit === 'function') {
                            window._groupRepeaterListInit();
                        }
                    }

                    classUtilitites.masksInputs();
                    classUtilitites.formInfoLoad(idSidebar);

                    let formToOrder = document.querySelector('#form-auto-reorder');
                    if(formToOrder){
                        classUtilitites.orderFieldsWrap();
                    }

                    classUtilitites.sidebarInfoTabs();

                    if ($('input[name="person"]:checked').length > 0) {
                        $('input[name="person"]:checked').trigger('click');
                    }

                    if ($("select[data-callback-field]").length > 0) {
                        $("select[data-callback-field]").each(function(){
                            let element = $(this);
                            let value = element.val();

                            if (value.length > 0) {
                                // sintético: só re-renderiza o select2 (formSelects acima), não deve
                                // disparar o ajax de options-disabled/option-selected como se fosse
                                // uma mudança real do usuário — selectCallbackField ignora esse marcador
                                element.trigger("change", { synthetic: true });
                            }
                        });
                    }

                    if ($('input[data-callback-field]').length > 0) {
                        $('input[data-callback-field]').each(function(){
                            let element = $(this);
                            let value = element.val();

                            if (value.length > 0) {
                                element.trigger("change");
                            }
                        });
                    }

                    classUtilitites.cloneElementToArea('.elmToClone','area-input-clonned');

                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var classUtilitites = new UtilitiesUP;

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });
        }
    }

    // load form info
    formInfoLoad(idSidebar){
        const idFormInfo = "#form-info-nav";

        if(!$(idFormInfo).length > 0) return;

        const form_Info_url = $(idFormInfo).attr("data-form_info_url");
        $.ajax({
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: form_Info_url+'?form_info_key='+idSidebar,
            data: {},
            dataType: "json",
            success: function (data) {

                if (Array.isArray(data.result) && data.result.length === 0) {
                    $("#btn-toggle-custom-sidebar").parent().hide();
                    return;
                }else{
                    $("#btn-toggle-custom-sidebar").parent().show();
                }

                setTimeout(function () {
                    document.getElementById("form_info_to_save").innerHTML = data.result.salvar.content;
                    document.getElementById("form_info_to_finalize").innerHTML = data.result.concluir.content;
                    document.getElementById("form_info_to_edite").innerHTML = data.result.editar.content;
                },500);

            },
            error: function (jqXHR, textStatus, errorThrown) {
                var classUtilitites = new UtilitiesUP;
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }

    // sidebar info tabs
    sidebarInfoTabs(){
        const sidebar = document.getElementById("custom-right-sidebar");
        const btnOpen = document.getElementById("btn-toggle-custom-sidebar");
        const btnClose = document.getElementById("btn-close-custom-sidebar");

        if(!sidebar)
            return;

        // Abrir sidebar (muda o 'right' de -300px para 0)
        btnOpen.addEventListener("click", function () {
            sidebar.style.right = "0px";
        });

        // Fechar sidebar (volta para -300px)
        btnClose.addEventListener("click", function () {
            sidebar.style.right = "-300px";
        });

        // Opcional: Fechar ao clicar fora do sidebar
        document.addEventListener("click", function (event) {
            if (!sidebar.contains(event.target) && !btnOpen.contains(event.target)) {
                sidebar.style.right = "-300px";
            }
        });
    }

    orderFieldsWrap(root = null){

        // product-combo-multi: a raiz e OPCIONAL e o default e o comportamento de sempre.
        // Sem argumento -> primeiro .parent-custom-form--tiptoe-tabs do documento (chamadores
        // atuais: app.js e o sidebar de info). Com raiz (ex.: a div do modal) -> o agrupamento
        // fica preso a subarvore dela e nao alcanca a aba que esta ATRAS do modal.
        const scope  = (root && typeof root.querySelector === 'function') ? root : document;
        const parent = scope.querySelector('.parent-custom-form--tiptoe-tabs');
        if (parent) {
            const wrapper = document.createElement('div');
            wrapper.className = 'wrap-campo-bloco';

            const rows = parent.querySelectorAll(':scope > .row');

            rows.forEach(row => {

                const wrapper = document.createElement('div');
                wrapper.className = 'wrap-campo-bloco';
                const titleGroup = row.querySelector('.class_group');
                if(titleGroup){
                    wrapper.innerHTML = '<h4 class="wrap-campo-bloco__titulo">'+titleGroup.getAttribute('placeholder')+'</h4>';
                }

                // Insere o wrapper antes da row atual
                row.parentNode.insertBefore(wrapper, row);

                // Move a row para dentro do wrapper
                wrapper.appendChild(row);

                // trata se nao tiver campo visivel
                if(row.clientHeight == 0) {
                    row.closest('.'+wrapper.className).style.display="none";
                }

            });
        }
    }

    cloneElementToArea(elmClone,areaClone){
        let destino  = document.getElementById(areaClone);
        if(!destino) return;

        let idOriginal = (document.querySelector(elmClone).name ? document.querySelector(elmClone).name : document.querySelector(elmClone).getAttribute('data-element')); //document.getElementById('link[2763][]');
        let original = document.getElementById(idOriginal);
        // console.log(elmClone, idOriginal ,original);
        let wrapper  = original.closest('.col-to-clone'); // pega a div inteira (label + select)

        // clona a div inteira (label + select), inclusive filhos
        let clone = wrapper.cloneNode(true);

        // ajusta o clone: fica visível, remove o display:none herdado
        clone.style.display = '';

        // pega o select dentro do clone
        let cloneSelect = clone.querySelector('select');

        // remove o name (pra não duplicar envio no submit)
        cloneSelect.removeAttribute('name');

        // gera um id novo pro clone, pra não colidir com o original
        var novoId = original.id + '_clone';
        cloneSelect.id = novoId;

        // oculto o select original
        if($('.wrap-campo-bloco').length > 0)
            wrapper.closest('.wrap-campo-bloco').classList.add('d-none');

        // ajusta o "for" do label clonado, se houver
        var cloneLabel = clone.querySelector('label');
        if (cloneLabel) {
            cloneLabel.setAttribute('for', novoId);
            cloneLabel.classList.add("text-right","mr-4","mb-0");
            cloneLabel.closest(".col-to-clone").classList.add("d-flex", "align-items-center");
        }

        // injeta o clone na nova área
        destino.innerHTML = '';
        destino.appendChild(clone);

        this.formSelects();

        // sincroniza clone -> original
        cloneSelect.addEventListener('change', function () {
            original.value = cloneSelect.value;
            original.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // sincroniza original -> clone (caso algo mude o original via outro script)
        original.addEventListener('change', function () {
            cloneSelect.value = original.value;
        });

    }

    checkChart() {
        $('[data-chart]').each(function () {
            let element = $(this);

            let type = element.data('type');
            let data = element.data('chart');
            let elementId = element.attr('id');

            if (type == 'pie') {
                chartPie(elementId, data);
            } else if (type == 'donut') {
                chartDonut(elementId, data);
            }
        });
    }

    masksInputs() {

        // $('.mask-phone').on('input', function(e) {
        //     $(this).val(function(i, v) {
        //         return v.replace(/[^\d]/gi, '');
        //     });
        // });
        // $('.mask-phone-ddi').on('input', function(e) {
        //     $(this).val(function(i, v) {
        //         return v.replace(/[^\d]/gi, '');
        //     });
        // });

        $('.mask-measures').mask("##0,00", {
            reverse: true
        });

        $('.mask-number').mask('00000');

        $('.mask-date').mask('00/00/0000', {
            placeholder: "dd/mm/yyyy"
        });

        $('.mask-hour').mask('00:00:00', {
            placeholder: "hh:mm:ss"
        });

        $('.mask-datetime').mask('00/00/0000 00:00:00', {
            placeholder: "dd/mm/yyyy hh:mm:ss"
        });

        $('.mask-zipcode').mask('00000-000', {
            placeholder: "99999-999"
        });

        $('.mask-phone').mask('99 999 999 999 999', {
            placeholder: ""
        });

        // new mask phone
        var SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
            spOptions = {
                onKeyPress: function (val, e, field, options) {
                    field.mask(SPMaskBehavior.apply({}, arguments), options);
                }
            };

        $('.mask-phone-2').mask(SPMaskBehavior, spOptions);


        $('.mask-phone-ddi').mask('999 99 999 999 999', {
            placeholder: "999 99 999 999 999"
        });


        $('.mask-cpf').mask('000.000.000-00', {
            placeholder: "000.000.000-00"
        });

        $('.mask-cnpj').mask('00.000.000/0000-00', {
            placeholder: "00.000.000/0000-00"
        });

        $('.mask-cnpj-15').mask('000.000.000/0000-00', {
            placeholder: "000.000.000/0000-00"
        });

        // $('.mask-money').mask('000.000.000.000.000,00', {
        //     reverse: true
        // });

        $('.mask-currency').mask("#.##0,00", {
            reverse: true
        });

        $('.mask-money').mask("#.##0,00", {
            reverse: true
        });

        $('.mask-percent').mask('##0,00', {
            reverse: true,
            max: 100
        });

        $('.datetimepicker').datetimepicker();
        $('#kt_datetimepicker_7_1').datetimepicker({
            useCurrent: false,
            format: "DD/MM/YYYY HH:mm"
        });
        $('#kt_datetimepicker_7_2').datetimepicker({
            useCurrent: false,
            format: "DD/MM/YYYY HH:mm"
        });
        $('#kt_datetimepicker_7_1').on('change.datetimepicker', function (e) {
            $('#kt_datetimepicker_7_2').datetimepicker('minDate', e.date);
        });
        $('#kt_datetimepicker_7_2').on('change.datetimepicker', function (e) {
            $('#kt_datetimepicker_7_1').datetimepicker('maxDate', e.date);
        });
    }

    // dispara o data-ajax de cada .execute-ajax-on-load dentro do escopo
    // (documento no load da página, ou o alvo de um conteúdo vindo via ajax)
    executeAjaxOnLoad(scope = document) {
        const classUtilitites = this;

        $(scope).find('.execute-ajax-on-load').each(function (index, element) {
            // remove a classe para não disparar de novo no próximo conteúdo injetado
            $(element).removeClass('execute-ajax-on-load');

            const pendente = { element: element, xhr: null };
            pendente.xhr = $.ajax({
                type: $(element).data('method') || "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: $(element).data('ajax'),
                data: $(element).data(),
                dataType: "json",
                complete: function () {
                    ajaxOnLoadPendentes.delete(pendente);
                },
                success: function (data) {
                    // O conteúdo que pediu a carga já foi trocado (ex.: outro ticket aberto). Os alvos têm id fixo
                    // (#ticket-detail-chat, #ticket-detail-timeline...), então aplicar agora poria o dado antigo na tela nova.
                    if (!document.contains(element)) return;
                    classUtilitites.switchReturns(data, element);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (textStatus === 'abort' || !document.contains(element)) return;
                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });
            ajaxOnLoadPendentes.add(pendente);
        });
    }

    // aborta as cargas em voo cujo elemento está dentro do conteúdo prestes a ser trocado
    abortAjaxOnLoad(target) {
        const alvos = $(target).toArray();
        ajaxOnLoadPendentes.forEach(function (p) {
            if (alvos.some(function (a) { return a.contains(p.element); })) {
                ajaxOnLoadPendentes.delete(p);
                p.xhr.abort();
            }
        });
    }

    processAjax(element) {
        var url_ajax = element.data("ajax");

        element.removeClass('process-ajax');

        setTimeout(function () {
            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: element.data(),
                dataType: "json",
                success: function (data) {
                    var classUtilitites = new UtilitiesUP;

                    // $('html').css('overflow', 'auto');

                    classUtilitites.switchReturns(data, element);

                    if ($('.process-ajax').length > 0) {
                        classUtilitites.processAjax($('.process-ajax').first())
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var classUtilitites = new UtilitiesUP;

                    // $('html').css('overflow', 'auto');

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            })
        }, 0);
    }

    // BUSCA em TABELAS
    tiraAcentos(i) {

        var i = i.toLowerCase().trim();

        var acentos = "ãáàâäéèêëíìîïõóòôöúùûüç";
        var sem_acentos = "aaaaaeeeeiiiiooooouuuuc";

        for (var x = 0; x < i.length; x++) {
            var str_pos = acentos.indexOf(i.substr(x, 1));
            if (str_pos != -1) {
                i = i.replace(acentos.charAt(str_pos), sem_acentos.charAt(str_pos));
            }
        }

        return i;
    }

    loadGallery() {
        console.log('loading galleryswiper');

        const galPadrao = ".swiper-padrao";

        // for( let i=0; i< $(galPadrao).length; i++ ) {
        $(galPadrao).each(function (e) {

            const _tGal = $(this);
            //if(_tGal.find('picture').length <= 1) return;


            let _parent = _tGal.closest('.row-gallery');

            _tGal.addClass('swiper-container-padrao-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-padrao-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-padrao-' + e);
            // _parent.find('.swiper-pagination').addClass('swiper-pagination-padrao-' + e);


            const swiperPadrao = new Swiper('.swiper-container-padrao-' + e, {
                // cssMode     : true,
                modules: [Navigation],
                speed: 1000,
                loop: true,
                effect: 'slide',
                autoplay: false,
                navigation: {
                    prevEl: '.swiper-button-prev-padrao-' + e,
                    nextEl: '.swiper-button-next-padrao-' + e,
                },
            });
        })

    }
}


function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

function chartPie(elementId, data) {
    let element = document.getElementById(elementId);

    let series = [];
    let labels = [];

    $.each(data, function (index, item) {
        series[index] = item.value
        labels[index] = item.label
    });

    let options = {
        chart: {
            type: 'pie',
        },
        plotOptions: {
            pie: {
                customScale: 1,
            }
        },
        series: series,
        labels: labels,
        colors: ['#D1D1D1', '#919191', '#444444', '#525252', '#333333'],
        legend: {
            show: false,
            position: 'bottom'
        }
    };

    let chart = new ApexCharts(element, options);
    chart.render();

    console.log('chartPie');
}

function chartDonut(elementId, data) {
    let element = document.getElementById(elementId);

    let series = [];
    let labels = [];

    $.each(data, function (index, item) {
        series[index] = item.value
        labels[index] = item.label
    });

    let options = {
        chart: {
            type: 'donut',
            height: 240
        },
        plotOptions: {
            donut: {
                customScale: 1,
            }
        },
        series: series,
        labels: labels,
        legend: {
            show: true,
            position: 'right'
        }
    };

    let chart = new ApexCharts(element, options);
    chart.render();
}
